import React from 'react'

import data from './data'

const FAQ = () => {
  return (
    <section className="faq">
      {data.map((itm, key) => {
        return (
          <div key={key} className="faq__item">
            <h3 className="faq__item__question">{itm.question}</h3>
            <div className="faq__item__answer">
              <p>{itm.answer}</p>
            </div>
          </div>
        )
      })}
    </section>
  )
}

export default FAQ
